import request from '@/utils/request'

// 首页banner图
export function getIndexConfig() {
    return request({
        url: '/api/index/public/img/banner',
        method: 'get'
    })
}

// 找工作图片
export function getJobImgList() {
    return request({
        url: '/api/index/public/img/job',
        method: 'get'
    })
}

// 找人才图片
export function getResumeImgList() {
    return request({
        url: '/api/index/public/img/resume',
        method: 'get'
    })
}
// 找底部导航
export function getFooterConfig() {
    return request({
        url: '/api/index/public/footer',
        method: 'get'
    })
}
